const AddendumSignType = {
  MG: [1, 'MG'],
  PR: [2, 'PR'],
  ZINGCHART: [3, 'ZINGCHART'],
  REVENUE: [4, 'REVENUE'],
};

export default AddendumSignType;
